import {
  ICustomRepeaterConfigurationFormModel,
  IFormbuilderFieldTypeConfiguration,
} from '../../../models/form-builder-types-configurations.model';
import { fieldsBaseConfigurationFormModel } from './shared.configuration';
import { FormBuilderService } from '../../../services/form-builder.service';
import {
  baseFieldParseIntoSettingsFormModel,
  baseFieldUpdateFromSettingsFormModel,
  getDefaultBaseSettingsConfigFormly,
} from '../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import {
  getRequiredValidatorFormConfig,
  getValidationFieldsFormConfig,
} from '../form-fields-formly-validations/form-fields-formly-validation-field-generator.util';
import { getFieldDisplayFormConfig } from '../form-fields-formly-display/form-fields-formly-display-field-generator.util';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { IFormFieldsValidationModel } from '../../../models/form-fields-formly-validation.model';
import { parseRequiredValidatorParseFieldIntoModel } from '../form-fields-formly-validations/form-fields-formly-validation-field-parse-to-model.util';
import { IFormFieldsDisplayModel } from '../../../models/form-fields-formly-display.model';
import { parseFieldIntoDisplayFormModel } from '../form-fields-formly-display/form-fields-formly-display-field-parse-to-model.util';
import { setDisplayHideExpressionFromModel } from '../form-fields-formly-display/form-fields-formly-display-field-set-from-model.util';
import { setRequiredValidatorUpdateFieldFromModel } from '../form-fields-formly-validations/form-fields-formly-validation-field-set-from-model.util';

export const defaultCustomRepeaterConfigFormModel: ICustomRepeaterConfigurationFormModel =
  {
    ...fieldsBaseConfigurationFormModel(),
    addText: 'Add subject',
    uniqueRepeaterValues: ['subject_name'],
  };

export const customRepeaterFieldGetConfigurationConfig = (
  formBuilderServiceInstance: FormBuilderService
): IFormbuilderFieldTypeConfiguration => {
  return {
    settings: {
      formModel: defaultCustomRepeaterConfigFormModel,
      formlyForm: [
        ...getDefaultBaseSettingsConfigFormly(formBuilderServiceInstance),
      ],
    },
    validations: {
      formModel: {},
      formlyForm: [
        getRequiredValidatorFormConfig(),
        getValidationFieldsFormConfig(formBuilderServiceInstance),
      ],
    },
    display: {
      formModel: {},
      formlyForm: [...getFieldDisplayFormConfig(formBuilderServiceInstance)],
    },
  };
};

export const customRepeaterFieldParseIntoSettingsFormModel = (
  field: FormlyFieldConfig
): ICustomRepeaterConfigurationFormModel => {
  const baseModel = baseFieldParseIntoSettingsFormModel(field);

  return {
    ...baseModel,
    addText: field.props?.['addText'] || 'Add subject',
    uniqueRepeaterValues: field.props?.['uniqueRepeaterValues'] || [
      'subject_name',
    ],
  };
};

export const customRepeaterFieldUpdateFromSettingsFormModel = (
  model: ICustomRepeaterConfigurationFormModel,
  inputField: FormlyFieldConfig
): FormlyFieldConfig => {
  // Update base field properties
  const field = baseFieldUpdateFromSettingsFormModel(model, inputField);

  // Ensure props exists
  field.props = field.props || {};
  // Set add text and unique repeater values if any
  field.props['addText'] = model.addText;
  field.props['uniqueRepeaterValues'] = model.uniqueRepeaterValues;

  return field;
};

export const customRepeaterFieldParseIntoValidationFormModel = (
  field: FormlyFieldConfig
): IFormFieldsValidationModel => {
  let model: IFormFieldsValidationModel = {};
  model = parseRequiredValidatorParseFieldIntoModel(model, field);
  return model;
};

export const customRepeaterFieldUpdateFromValidationFormModel = (
  model: IFormFieldsValidationModel,
  inputField: FormlyFieldConfig
): FormlyFieldConfig => {
  return setRequiredValidatorUpdateFieldFromModel(model, inputField);
};

export const customRepeaterFieldParseFieldIntoDisplayFormModel = (
  field: FormlyFieldConfig
): IFormFieldsDisplayModel => {
  return parseFieldIntoDisplayFormModel(field);
};

export const customRepeaterFieldUpdateFromDisplayFormModel = (
  model: IFormFieldsDisplayModel,
  field: FormlyFieldConfig
): FormlyFieldConfig => {
  return setDisplayHideExpressionFromModel(model, field);
};
